export { default } from './wrapperValue.js'



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-es/value.js
// module id = 1258
// module chunks = 0